import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

const loader = lazyForPaint(
    () => {
        return import(/* webpackChunkName: "user-profile-hub-variant" */ './hub-variant');
    },
    {
        ssr: true,
    }
);

export const UserProfileForHubs = withAsync({
    loader,
});
